import { RecordContextProvider, useGetOne } from "react-admin";
import { currentUser } from "../../backoffice.access_control";
import { PageTitle } from "../PageTitle";
import { LoadingIndicator } from "../LoadingIndicator";
import { InstructorCalendar } from "./InstructorCalendar";
import { Instructor } from "../../providers/instructorsProvider";

export function MyCalendar() {
  const { data: currentInstructor } = useGetOne<Instructor>("instructors", { id: currentUser!.uid });

  return (
    <>
      <PageTitle>Mein Kalender</PageTitle>
      {!currentInstructor && <LoadingIndicator />}
      {currentInstructor && (
        <RecordContextProvider value={currentInstructor}>
          <InstructorCalendar />
        </RecordContextProvider>
      )}
    </>
  );
}
